import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-unloading",
  "use": "icon-unloading-usage",
  "viewBox": "0 0 1075 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1075 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-unloading\"><defs><style type=\"text/css\"></style></defs><path d=\"M1038.7456 699.4944H268.288a40.8064 40.8064 0 0 1-40.8576-40.448V511.8464c0-22.2208 18.432-40.448 40.8576-40.448h770.4576v228.096z\" fill=\"#1296db\" p-id=\"1833\" /><path d=\"M263.168 0v29.4912l746.24 440.2176-104.8576 0.6144L263.6288 92.0576 263.168 68.096v654.6432h775.5776v178.0224L263.168 900.608v120.7296H0V0h263.168z m642.2528 774.9632l-43.9808 73.3184 124.928 0.0512v-73.3184h-80.896z m-534.7328 0l-107.52 0.0512v73.3184h63.5392l44.032-73.3696z m120.4736 0h-67.584l-43.9808 73.3184h67.584l44.032-73.3184z m120.4736 0h-67.584l-44.032 73.3184h67.6352l44.032-73.3184z m120.4736 0h-67.584l-44.032 73.3184h67.6352l44.032-73.3184z m120.4736 0h-67.584l-44.032 73.3184h67.6352l44.032-73.3184z\" fill=\"#1296db\" p-id=\"1834\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/unloading.svg
// module id = orG9
// module chunks = 197